import { render, staticRenderFns } from "./EditorDomManage.vue?vue&type=template&id=4f48c6db&"
import script from "./EditorDomManage.vue?vue&type=script&lang=js&"
export * from "./EditorDomManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports